import { LendingYacht } from '@/types/lending';
import { SVSummaryCard } from '../core';
import { formatDateTimeFromUTC } from '@/utils/date';
import { formatCurrency } from '@/utils/currency';

type LendingYachtDetailsProps = {
  loanRequest: LendingYacht;
};

export default function LendingYachtDetails({
  loanRequest,
}: LendingYachtDetailsProps) {
  const {
    customerEmail,
    customerName,
    customerPhone,
    submittedAt,
    model,
    requestedLoanAmount,
    downPaymentAmount,
    estimatedCreditScore,
  } = loanRequest;

  return (
    <SVSummaryCard
      label="Yacht Loan Request Details"
      items={[
        { label: 'Name', text: customerName },
        { label: 'Email', text: customerEmail },
        { label: 'Phone', text: customerPhone },
        {
          label: 'Submitted At',
          text: formatDateTimeFromUTC(submittedAt),
        },
        { label: 'Model', text: model },
        {
          label: 'Request Loan Amount',
          text: formatCurrency({ amount: requestedLoanAmount }),
        },
        {
          label: 'Downpayment Amount',
          text: formatCurrency({ amount: downPaymentAmount }),
        },
        { label: 'Estimated Credit Score', text: estimatedCreditScore },
      ]}
    />
  );
}
